import React from 'react'
const CTA = ({ resumeUrl }) => {
  return (
    <div className="cta">
        <a href={resumeUrl} target="_blank" rel="noreferrer" className='btn'>View Resume</a>
        <a href="#contact" className='btn btn-primary'>Let's talk</a>
    </div>
  )
}

export default CTA